"use client";
import { useRouter, useSearchParams } from "next/navigation";
import { DiscoveryBook } from "./DiscoveryBook";
import { DiscoverySerie } from "./DiscoverySerie";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

type Tab = "series" | "books";

interface TabsComponentProps {
  page: number;
  tab?: Tab;
}

export function TabsComponent({ page, tab = "series" }: TabsComponentProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleTabChange = (value: Tab) => {
    const params = new URLSearchParams(searchParams?.toString() || "");
    params.set("tab", value);
    params.set("page", "1");
    router.push(`?${params.toString()}`, { scroll: false });
  };

  return (
    <Tabs defaultValue={tab} onValueChange={value => handleTabChange(value as Tab)}>
      <TabsList className="mb-2 max-md:w-full">
        <TabsTrigger className="max-md:w-[50%]" value="series">
          Series
        </TabsTrigger>
        <TabsTrigger className="max-md:w-[50%]" value="books">
          Books
        </TabsTrigger>
      </TabsList>
      <TabsContent value="series">
        <div className="w-full">
          <DiscoverySerie page={page} />
        </div>
      </TabsContent>
      <TabsContent value="books" className="w-full">
        <div className="w-full">
          <DiscoveryBook page={page} />
        </div>
      </TabsContent>
    </Tabs>
  );
}
